/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDimensionFromJSON, ApiDimensionToJSON, } from './ApiDimension';
export function ApiActiveCustomersTrendPayloadFromJSON(json) {
    return ApiActiveCustomersTrendPayloadFromJSONTyped(json, false);
}
export function ApiActiveCustomersTrendPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'granularity': !exists(json, 'granularity') ? undefined : ApiDimensionFromJSON(json['granularity']),
        'lastNDays': !exists(json, 'lastNDays') ? undefined : json['lastNDays'],
        'to': !exists(json, 'to') ? undefined : (new Date(json['to'])),
        'windowDays': !exists(json, 'windowDays') ? undefined : json['windowDays'],
    };
}
export function ApiActiveCustomersTrendPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'granularity': ApiDimensionToJSON(value.granularity),
        'lastNDays': value.lastNDays,
        'to': value.to === undefined ? undefined : (value.to.toISOString()),
        'windowDays': value.windowDays,
    };
}
